import { ObtenerCatalogo, Cargando, Error } from "../Types/Catalogo.type";
import { firebaseFS } from "../Firebase/FirebaseApp";
import { dispatchController } from "./index.actions";
import { __Colecciones } from "./../environment";

export const obtenerCatalogo = (clasificacion) => async (dispatch) => {
  try {
    dispatch({
      type: Cargando,
    });

    let catalogos = [];
    const respuesta = await firebaseFS
      .collection(__Colecciones.Catalogo)
      .where("Clasificacion", "==", clasificacion);
    await respuesta.get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        catalogos = [
          ...catalogos,
          {
            id: doc.id,
            datos: doc.data(),
          },
        ];
      });
    });

    const bodyJson = {
      Resultado: "S",
      Mensaje: "",
      Datos: catalogos,
    };

    dispatchController(ObtenerCatalogo, Error, dispatch, bodyJson);
  } catch (error) {
    dispatch({
      type: Error,
      Mensaje: error.message,
    });
  }
};
